var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart_main"},[_c('div',{ref:"mychart",staticStyle:{"width":"50%","height":"100%"}}),_c('div',{ref:"mychart1",staticStyle:{"width":"50%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }